var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatplotlib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    stroke: "gray",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 88
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 2v176m62-26L28 28m124 0L28 152m150-62H2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#44c",
    d: "M90 90h18a18 18 0 0 0 0-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc3",
    d: "m90 90 34-43a55 55 0 0 0-15-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d93",
    d: "M90 90 74 18a74 74 0 0 0-31 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db3",
    d: "M90 90 32 62a65 65 0 0 0-5 39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3bb",
    d: "m90 90-33 16a37 37 0 0 0 2 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c9",
    d: "m90 90-10 45a46 46 0 0 0 18 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d73",
    d: "m90 90 46 58a74 74 0 0 0 12-12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatplotlib);
export default __webpack_public_path__ + "static/media/matplotlib.56dcb09c3403b80717eb37bc4cf296fe.svg";
export { ForwardRef as ReactComponent };